import React from 'react'

import Navigation from '../Components/Navigation/Navigation'
import Footer from '../Components/Footer/Footer'

const Report = () => {
  return (
    <div>
      <Navigation />
      <div className='flex flex-row w-full items-center justify-center py-24'>
        報告頁面建置中，請聯絡我們以獲取更多資訊。
      </div>
      <Footer />
    </div>
  )
}

export default Report